import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _9kIcon(props: IconProps) {
    return <Icon {...props} iconKey={"9k"}/>
}
